import React, { useRef, useState } from 'react'
import SpinnerForPage from '../../../components/spinner/SpinnerForPage'
import swal from "sweetalert";
import { useDeleteWasteCategoryuserAppMutation, useGetWasteCategoryuserAppQuery } from './WasteCategorySlice';
import WasteCategoryEdit from './WasteCategoryEdit';
import AddWasteCategory from './AddWasteCategory';
import Swal from 'sweetalert2';

function WasteCategory() {
    const [editData, setEditData] = useState({});

    const {
        data: WasteCategoryUserApp,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetWasteCategoryuserAppQuery('getWasteCategoryuserApp');

    // data Delet 
    const [deleteWasteCategoryuserApp] = useDeleteWasteCategoryuserAppMutation();
    const deleteHandle = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Warning ! Action might affect user application",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: "Deleted!",
                    text: "Your file has been deleted.",
                    icon: "success"
                });
                deleteWasteCategoryuserApp(id).unwrap();
            }
        });

        // try {
        //     await deleteWasteCategoryuserApp(id).unwrap();
        //     swal("Done", "Data Deleted Successfully", "success")
        // } catch (error) {
        //     swal("Error", "Failed to delete the  data", "")
        // }
    };

    // data Edit 
    const refOpen = useRef();

    const editCommunity = (ID) => {
        refOpen.current.click();
        const data = WasteCategoryUserApp.find(item => item.id === ID);
        setEditData({ id: data?.id, name: data?.name, active: data?.active, unit: data?.unit })
    }

    return (
        <>
            {isLoading && <SpinnerForPage />}
            <div className="container-fluid mt-5">
                {/* User Add Buttone */}
                <div className="d-flex justify-content-end mb-2">
                    <div className="text-right">
                        <AddWasteCategory />
                    </div>
                </div>

                <div className="card card-dark mt-4">
                    <div className="table-border-style">
                        <div className="table-responsive">
                            <table className="table table-striped">
                                <thead className="mobile-hidden">
                                    <tr className="text-left">
                                        <th scope="col">Sr. No.</th>
                                        <th scope="col">Name</th>
                                        <th scope="col">image</th>
                                        <th scope="col">Active</th>
                                        <th scope="col">Unit</th>
                                        <th scope="col">Price</th>
                                        <th scope="col">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        WasteCategoryUserApp?.map((index, e) => {
                                            return <tr key={index} className="mobile-hidden listData text-left fw-normal">
                                                <td>{e + 1}</td>
                                                <td>{index?.name}</td>
                                                <td><img className='WasteCategoryImagelist' src={"https://apis.ecowrap.in/b2gUserWasteCategory/" + index?.image} alt="Image" /></td>
                                                <td>{index?.active == 1 ? 'Yes' : "No"}</td>
                                                <td>{index?.unit}</td>
                                                <td>{index?.price}</td>

                                                <td>
                                                    <div className="dropdown">
                                                        <button
                                                            className="btn dropdown-toggle p-2"
                                                            type="button"
                                                            id="dropdownMenuButton1"
                                                            data-bs-toggle="dropdown"
                                                            aria-expanded="false"
                                                            style={{ border: 'none' }}
                                                        >
                                                            <i className="fas fa-ellipsis-v" style={{ color: 'gray' }}></i>
                                                        </button>
                                                        <ul className="dropdown_Box dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                            <li>
                                                                <div
                                                                    className="dropdown-item"
                                                                    onClick={() => editCommunity(index?.id)}
                                                                    style={{ cursor: 'pointer' }}
                                                                >
                                                                    Edit
                                                                </div>
                                                                <div
                                                                    className="dropdown-item"
                                                                    onClick={() => deleteHandle(index?.id)}
                                                                    style={{ cursor: 'pointer' }}
                                                                >
                                                                    Delete
                                                                </div>

                                                            </li>
                                                        </ul>
                                                    </div>
                                                </td>
                                            </tr>
                                        })
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className="daily_collection">
                    {WasteCategoryUserApp?.map((index, e) => {
                        return <div key={index} className="Card_table_data ">
                            <div div className="Card_data">
                                <span className="Card_srNo">#</span>
                                <span className="Card_data_list">{e + 1}</span>
                            </div>
                            <div className="Card">
                                <div className="Card_data">
                                    <span className="Card_srNo">Name:-</span>
                                    <span className="Card_data_list">{index?.name}</span>
                                </div>
                                <div className="Card_data">
                                    <span className="Card_srNo">image:-</span>
                                    <span className="Card_data_list"><img className='WasteCategoryImagelist' src={"https://apis.ecowrap.in/b2gUserWasteCategory/" + index?.image} alt="Image" /></span>
                                </div>
                            </div>
                            <div className="Card">
                                <div className="Card_data">
                                    <span className="Card_srNo">Active:-</span>
                                    <span className="Card_data_list">{index?.active == 1 ? 'Yes' : "No"}</span>
                                </div>
                                <div className="Card_data">
                                    <span className="Card_srNo">Unit:-</span>
                                    <span className="Card_data_list">{index?.unit}</span>
                                </div>
                            </div>
                            <div className="Card">
                                <div className="Card_data">
                                    <span className="Card_srNo">Price:-</span>
                                    <span className="Card_data_list">{index?.price}</span>
                                </div>
                                <div className="Card_data">
                                    <span className="Card_srNo">Action:-</span>
                                    <span className="Card_data_list"><div className="dropdown">
                                        <button
                                            className="btn dropdown-toggle p-2"
                                            type="button"
                                            id="dropdownMenuButton1"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                            style={{ border: 'none' }}
                                        >
                                            <i className="fas fa-ellipsis-v" style={{ color: 'gray' }}></i>
                                        </button>
                                        <ul className="dropdown_Box dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                            <li>
                                                <div
                                                    className="dropdown-item"
                                                    onClick={() => editCommunity(index?.id)}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    Edit
                                                </div>
                                                <div
                                                    className="dropdown-item"
                                                    onClick={() => deleteHandle(index?.id)}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    Delete
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    </span>
                                </div>
                            </div>
                        </div>
                    })}
                </div>
            </div>
            <WasteCategoryEdit
                refOpen={refOpen}
                setEditData={setEditData}
                editData={editData}
            />
        </>
    )
}

export default WasteCategory;